import React from 'react';
import { Text } from '../../../../CommonComponents/OPL/Text/Text';
import { ColumnHeader } from '../../../OtherAssets/OtherAssets.meta';
import { IncomeTable } from '../../components/IncomeTable/IncomeTable';
import { formatCurrency } from '../../../../CommonUtils/formatNumber';
import { IncomeTableProps } from '../../Income.meta';
import { RealEstateEmpty } from './RealEstate.empty';
import { TableActions } from '../../components/TableActions/TableActions';
import { ClickableTableRow } from '../../../../CommonComponents/OPL/HtmlTable/HtmlTable';

const columnHeaders: ColumnHeader[] = [
  { text: 'Owner' },
  { text: 'Name' },
  { text: 'Yearly Amount', align: 'right' },
];

export const RealEstate = ({
  data,
  clientId,
  incomeType,
  setIncomeToUpsert,
  setIncomeToDelete,
  workflowProps,
}: IncomeTableProps) => {
  const {
    Options: { IncomeTypeOptions, RealEstateAssetOptions },
  } = data;

  const incomes = data.incomesDict[incomeType];

  const incomeTitle =
    IncomeTypeOptions.find(option => option.value === incomeType)?.label || 'Real Estate Income';

  return (
    <IncomeTable
      title={incomeTitle}
      isEmpty={incomes.length === 0}
      emptyState={
        RealEstateAssetOptions.length === 0 ? (
          <RealEstateEmpty clientId={clientId} workflowProps={workflowProps} />
        ) : null
      }
      columnHeaders={columnHeaders}
      workflowProps={workflowProps}
    >
      {incomes.map(income => (
        <ClickableTableRow
          variant="clickable"
          key={income.Id}
          onClick={() => {
            setIncomeToUpsert(income);
          }}
        >
          <td>
            <Text fontWeight={500} textAlign="left" width="100%">
              {income.Earner}
            </Text>
          </td>

          <td>
            <Text fontWeight={500} textAlign="left">
              {income.Name}
            </Text>
          </td>

          <td>
            <Text variant="tabular" fontWeight={500} textAlign="right">
              {income.Amount !== null ? formatCurrency(income.Amount) : '-'}
            </Text>
          </td>

          <TableActions
            incomeName={incomeTitle}
            onEdit={() => setIncomeToUpsert(income)}
            onDelete={() => setIncomeToDelete({ id: income.Id, name: income.Name })}
          />
        </ClickableTableRow>
      ))}
    </IncomeTable>
  );
};
